module.exports = __webpack_public_path__ + "static/media/img-099.4fdf18c4.jpg";